var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"text-h1 mb-16 pb-16 text-center mt-16 pt-16"},[_vm._v(" How To Apply ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }